
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4f3b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4f3b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8acAo", function(module, exports) {

$parcel$export(module.exports, "register", () => $5f190538f21d4b7a$export$6503ec6e8aabbaf, (v) => $5f190538f21d4b7a$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $5f190538f21d4b7a$export$f7ad0328861e2f03, (v) => $5f190538f21d4b7a$export$f7ad0328861e2f03 = v);
var $5f190538f21d4b7a$export$6503ec6e8aabbaf;
var $5f190538f21d4b7a$export$f7ad0328861e2f03;
"use strict";
var $5f190538f21d4b7a$var$mapping = new Map();
function $5f190538f21d4b7a$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$5f190538f21d4b7a$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $5f190538f21d4b7a$var$resolve(id) {
    var resolved = $5f190538f21d4b7a$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$5f190538f21d4b7a$export$6503ec6e8aabbaf = $5f190538f21d4b7a$var$register;
$5f190538f21d4b7a$export$f7ad0328861e2f03 = $5f190538f21d4b7a$var$resolve;

});

var $fc2d971de9d635c7$exports = {};

(parcelRequire("8acAo")).register(new URL("", import.meta.url).toString(), JSON.parse('["f6R1R","index.19482ef1.js","kGTAZ","privacy_policy.6a4402e6.pdf","2AhY8","unika_checkup_terms.f5be80a6.pdf","hsy2u","unika_logo_white.becc4144.svg","6r5tl","opengraph.5f349a18.png","eFPTp","bankid.5093793f.svg","8MJVW","amtrust.6e556d0e.pdf","961Zv","company.c4c74684.pdf","4UTlr","product.0e5aa888.png","ku3mG","doctor_paper.fc51809f.svg","cd0x4","doctor_scanner.69088a58.svg","4Pg3P","doctor_table.630f697f.svg","ly0O4","doctor_xray.1f99174f.svg","kNtLk","faktablad-preview.0318d883.png","6djPL","faktablad2023.f42c9068.pdf","2UiKX","purchaseinfo-preview.c61f1ddc.png","aEFK2","purchaseinfo2023.a391ce6e.pdf","kt7ls","villkor-preview.5488efa9.png","eEPYm","villkor2023.599b669e.pdf","EIQwd","GrowLottie.33750f96.js","gaRih","27-globe-outline-unika.a58abad9.js","5VaEY","27-globe-outline-white.8197fe8e.js","byWxn","about-optimised.220d5bd0.m4v","3ZCWq","about.99844b30.png","ii0kw","bankid_white.cf45bc47.svg","7zqrx","Agreement.e377a155.js","d2zS5","agreement.37616ef5.js","4fQKc","bankgirot.4932c150.svg","7xcXe","trustly.fd2c4159.svg","4RMoP","Faktablad.d62be7fb.js","aYKBm","eiopa-area.4c687852.svg","7by7E","eiopa-cancellation.3ea93e34.svg","4govA","eiopa-duration.eeffb63e.svg","8hIIa","eiopa-important.d86c4ad2.svg","g214Q","eiopa-included.f4d15c58.svg","l4aXo","eiopa-not-included.9fd892dd.svg","9ldCk","eiopa-obligations.2e6437fe.svg","kMuwN","eiopa-price.46fe45d8.svg","4fbli","Letter.358b0f15.js","kqIqz","erik-vd-signature.1043f8e7.svg","5L7PG","PurchaseInfo.65151c76.js","dF1mm","axeria.313a4fc6.png","bI2DI","further.4835b0be.png","5D7nb","unika_logo_pinguin.bb34fa84.svg","5INpe","Referral.818143e6.js","hfoH1","About.211d5a4c.js","bSs5q","20-love-heart-outline-unika.1a95f37e.js","c8Qcx","20-love-heart-outline-white.02204ded.js","aQPXX","BrokerSignup.3e43f658.js","bYyvm","CheckupOrder.5ef4e5bb.js","4VxGH","Contacts.f4c1747b.js","5rIff","Admin.b702500f.js","f1TPy","html2canvas.a8084fe5.js","fpjuY","purify.c2cf1d36.js","jLU1X","index.es.26f131c7.js","9JqkD","Profile.07809c44.js","jQMCy","Broker.0ea46863.js","frM9G","BrokerAgreement.5eb948ce.js","2mMPD","BrokerChild.aaf8879f.js","5LxWc","BrokerCoinsured.3f971b2f.js","lJdL7","Employee.0f05cc37.js","aqcqo","Group.10ce0ad6.js","KDXIL","TermsAndConditions.27baf72d.js","1WwMR","index.7dccba57.css"]'));


//# sourceMappingURL=index.runtime.85459cb6.js.map
